import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EGetAlertsActions, GetAlertsFailure, GetAlertsPost, GetAlertsSuccess } from '../actions/get-alerts.actions';
import { GetAlertsService } from '@eview/core/services/get-alerts.service';

@Injectable()
export class GetAlertsEffects {
  constructor(private getAlertsService: GetAlertsService) {}

  private readonly actions$ = inject(Actions);

  getAlerts$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetAlertsPost>(EGetAlertsActions.GetAlertsPost),
      map(action => action.payload),
      switchMap(payload =>
        this.getAlertsService.getAlertsPost(payload).pipe(
          map(result => (result.success ? new GetAlertsSuccess() : new GetAlertsFailure())),
          catchError(() => of(new GetAlertsFailure()))
        )
      )
    )
  );
}
